import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import ClientForm from '../../NewApplication/components/ClientForm';
import SecureNewClient from '../../NewApplication/components/SecureNewClient';
import VerifyExistingClient from '../../NewApplication/components/VerifyExistingClient';
import { useApplicationStore } from '../../NewApplication/components/applicationStore';

const ProfileModal = ({ isOpen, client, onClose, onSaveAndClose }) => {
	const modalRef = useRef();
	const { setExistingClient, reset, getClient, getApplication } =
		useApplicationStore();
	const [isExistingConfirmed, setExistingConfirmed] = useState(false);
	const [isStubAccount, setIsStubAccount] = useState(false);
	const [isCreatingAccount, setIsCreatingAccount] = useState(false);
	const [updateAppStore, setUpdateAppStore] = useState(false);
	useEffect(() => {
		if (isOpen) {
			modalRef.current.showModal();
			setExistingClient(client);
		} else {
			modalRef.current.close();
			setExistingConfirmed(false);
			setIsCreatingAccount(false);
			reset();
		}
	}, [isOpen]);
	useEffect(() => {
		if (updateAppStore && isStubAccount && isCreatingAccount) {
			onSaveAndClose(getApplication().client);
		}
	}, [updateAppStore, isStubAccount, isCreatingAccount]);
	const handleSave = () => {
		if (isStubAccount && isCreatingAccount) {
			setUpdateAppStore(true);
		} else {
			onSaveAndClose(getClient());
		}
	};
	const handleSaveAndContinue = (event) => {
		event.preventDefault();
		onSaveAndClose(getClient(), true);
		setIsCreatingAccount(true);
	};
	return (
		<dialog id="profile-dialog" className="modal modal-top" ref={modalRef}>
			<div className="modal-box">
				<h3>Update Client Profile</h3>
				{isExistingConfirmed ? (
					<>
						{isCreatingAccount ? (
							<div className="flex flex-col">
								<div className="self-center w-2/3">
									<SecureNewClient
										showSkip={false}
										updateAppStore={updateAppStore}
									/>
								</div>
							</div>
						) : (
							<div className="grid grid-cols-1 gap-x-4 gap-y-2 sm:grid-cols-8">
								<ClientForm />
							</div>
						)}
					</>
				) : (
					<VerifyExistingClient
						isExistingConfirmed={isExistingConfirmed}
						setExistingConfirmed={setExistingConfirmed}
						onStubbedAccountConfirmed={() => setIsStubAccount(true)}
						isProfileUpdate
					/>
				)}
				<div className="modal-action">
					<form method="dialog">
						{isExistingConfirmed ? (
							<>
								<button
									className="btn btn-outline btn-primary"
									onClick={onClose}
								>
									Cancel
								</button>
								{isStubAccount && !isCreatingAccount && (
									<button
										className="ml-4 btn btn-primary"
										onClick={handleSaveAndContinue}
									>
										Save &amp; Continue
									</button>
								)}
								<button className="ml-4 btn btn-primary" onClick={handleSave}>
									Save &amp; Close
								</button>
							</>
						) : (
							<button className="btn btn-primary" onClick={onClose}>
								Close
							</button>
						)}
					</form>
				</div>
			</div>
		</dialog>
	);
};
ProfileModal.propTypes = {
	isOpen: PropTypes.bool,
	client: PropTypes.object,
	onClose: PropTypes.func.isRequired,
	onSaveAndClose: PropTypes.func.isRequired,
};

export default ProfileModal;
